import styled from '@emotion/styled'
import { getSizeValues } from '../../patterns/Inputs/utils'

const withStyle = (TextInput) =>
  styled(TextInput)((props) => {
    const { size, theme, width, inline } = props
    const { fontSize, lineHeight, footerAlign } = getSizeValues(size, theme)

    const overrideGlobalHasErrorStyles = () => `
        border: none;
        box-shadow: none;
      `
    return `
        && {
          ${inline ? 'display: inline-block;' : ''}
          font-family: Arial;
          font-weight: normal;
          width: ${width === 'auto' ? width : `${width}px`};
          letter-spacing: normal;
          line-height: ${lineHeight};
          font-size: ${fontSize};
          .ant-input-affix-wrapper {
            line-height: ${lineHeight};
            font-size: ${fontSize};
          }
          &.has-error {
            ${overrideGlobalHasErrorStyles()}
            .ant-input, .ant-input-number {
              border-color: ${theme.inputBorderErrorColor};
              &:focus {
                border-color: ${theme.inputBorderErrorColor};
                box-shadow: 0 0 3px ${theme.inputBorderErrorFocusColor};
              }
            }
            .input-footer {
              color: ${theme.inputFooterErrorColor};
            }
          }
          .ant-input, .ant-input-number {
            font-size: ${fontSize};
            line-height: ${lineHeight};
            width: 100%;
            border-radius: 3px;
            border: 1px solid;
            border-color: ${theme.inputBorderColor};
            background-color: ${theme.inputBgColor};
            color: ${theme.inputFontColor};
            .ant-input-number-handler-wrap {
              opacity: 1;
            }
            &::placholder {
              color: ${theme.inputPlaceholderColor};
            }
            &:focus {
              border-color: ${theme.inputBorderFocusColor};
              box-shadow: 0 0 2px ${theme.inputBorderFocusAccentColor};
            }
            &:hover {
              border-color: ${theme.inputBorderHoverColor};
            }
            &-prefix {
              color: ${theme.prefixFontColor};
            }
            &-suffix {
              color: ${theme.suffixFontColor};
            }
            &[disabled], &-disabled {
              color: ${theme.inputFontDisabledColor};
              background-color: ${theme.inputBgDisabledColor};
              border-color: ${theme.inputBorderDisabledColor};
            }
          }
          .input-footer {
            width: 100%;
            display: inline-block;
            text-align: ${footerAlign};
            font-size: 12px;
          }
          .input-footer-textArea {
            text-align: right;
            bottom: 2px;
            font-size: 12px;
          }
        }
      `
  })

export default withStyle

export const ErrorMessage = styled.div((props) => {
  const {
    theme: { inputDefaultFooterAlign, inputFooterErrorColor },
  } = props

  return `
    width: 100%;
    display: inline-block;
    text-align: ${inputDefaultFooterAlign};
    font-size: 12px;
    color: ${inputFooterErrorColor};
  `
})

export const SelectMenuStyled = styled.div((props) => {
  const {
    theme: { inputBorderErrorColor, inputBorderErrorFocusColor },
  } = props
  return `
    .has-error {
      border: none;
      box-shadow: initial;
      .ant-input, .ant-input-number, .ant-select-selection {
        border-color: ${inputBorderErrorColor};
        &:focus {
          border-color: ${inputBorderErrorColor};
          box-shadow: 0 0 3px ${inputBorderErrorFocusColor};
        }
      }
    }
  `
})
